import { EventRoleStatus } from '@type/db-types';
import { createContext, useContext } from 'react';

export interface ManagedEventsContextValues {
    loading: boolean;
    managedEvents: EventRoleStatus[];
    refresh: () => void;
}

export const ManagedEventsContext = createContext<ManagedEventsContextValues>({
    loading: true,
    managedEvents: [],
    refresh: () => undefined,
});

const useManagedEvents = () => {
    const ctx = useContext(ManagedEventsContext);

    if (!ctx) console.error('useManagedEvents called outside of ManagedEventsProvider Context');

    return ctx;
};

export default useManagedEvents;
